import styled from 'styled-components/macro'

const SearchResultContent = styled.div``

export default SearchResultContent
